import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/activity/expense-entry/category/query/', 'Activities');

tbl.add(new Xtc('expense_type', 'Categories').renderSlot('expense_type'))
tbl.add(new Xtc('name', 'Name'))
tbl.add(new Xtc('rate', 'Rate').renderSlot('rate'))
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

